import React from "react";
import "./book-page.m.css";

import HouseBlocks from "./house-blocks";
import UpcomingBookBlocks from "./upcoming-books";
import AuthorEventBlocks from "./author-events"
import Newsletter from "./newsletter"
import ContactUs from "./contact"

export default function BookClubPage() {
  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <div styleName="book-page">

      {/* Hero */}
      <section styleName="hero-section">

        {/* Desktop Hero */}
        <img
          src="https://images.assettype.com/newslaundry/2026-06-05/bychsezc/Hero.png"
          alt=""
          styleName="hero-image hero-desktop"
        />

        {/* Mobile Hero */}
        <img
          src="https://images.assettype.com/newslaundry/2026-07-03/clhgwu6f/hero.png"
          alt=""
          styleName="hero-image hero-mobile"
        />

        <div styleName="hero-buttons">

          <button
            styleName="hero-button hero-contact"
            onClick={() => scrollToSection("contact-section")}
          >
            Contact Us
          </button>

          <button
            styleName="hero-button hero-newsletter"
            onClick={() => scrollToSection("newsletter-section")}
          >
            Join our Newsletter
          </button>

          <button
            styleName="hero-button hero-book"
            onClick={() => scrollToSection("current-book-section")}
          >
            Explore Our Current Book
          </button>

        </div>

      </section>

      {/* About */}

      <section styleName="about-section">

        <img
          src="https://images.assettype.com/newslaundry/2026-06-05/efnl7bna/About-Us-.png"
          alt=""
          styleName="about-image about-desktop"
        />

        <img
          src="https://images.assettype.com/newslaundry/2026-07-03/wj5y3byx/ABOUT-US.png"
          alt=""
          styleName="about-image about-mobile"
        />

      </section>

      <HouseBlocks />

            {/* Current Book */}

      <section
        id="current-book-section"
        styleName="current-book-section"
        onClick={() => {
          window.location.href = "/book-club";
        }}
      >
        {/* Desktop */}

        <img
          src="https://images.assettype.com/newslaundry/2026-08-07/ebbdr164/book.png"
          alt=""
          styleName="current-book-image current-book-desktop"
        />

        {/* Mobile */}

        <img
          src="https://images.assettype.com/newslaundry/2026-08-07/mn0egld3/bookmobile.png"
          alt=""
          styleName="current-book-image current-book-mobile"
        />
      </section>

      <UpcomingBookBlocks />

      <AuthorEventBlocks />

      <Newsletter />

      <ContactUs />
    </div>
  );
}